{
  "slug": "highest-iq-ever-recorded",
  "title": "什么是有记录以来最高的智商?",
  "description": "研究著名的最高智商声明,测试上限,不兼容的分数尺度,以及为什么没有科学上确定的世界排名存在。",
  "summary": "对于最高智商问题没有一个单一的可辩护的答案，非常高的分数很难估计，测试使用不同的尺度和上限，许多著名的主张缺乏经过认证的报告。",
  "category": "智商分数解释",
  "sections": [
    {
      "heading": "为什么记录索赔不能直接比较",
      "paragraphs": [
        "智商数字只对指定的仪器、版本、年龄标准、分数类型和管理有意义。 一个分数不能直接与另一个分数进行比较,而需要进行合理的转换。",
        "老式的比率智商计算、现代偏差分数、童年结果、扩展规范和无监督测验经常混在流行的测试列表中,即使它们回答了不同的测量问题。"
      ]
    },
    {
      "heading": "极端分数具有更大的不确定性",
      "paragraphs": [
        "测试包含有限数量和难度范围的项目,接近上限时,小的原始分数差异可能会产生大报告差异,而参考样本包含的可比观测数据相对较少。",
        "因此,在极端尾部的看起来精确的值应该根据其置信区间和技术限制进行解释。 外推值不等于直接支持的分数。"
      ]
    },
    {
      "heading": "如何评估一个著名的主张",
      "paragraphs": [
        "查找一份主要报告,其中列出测试名称、版本、日期、年龄、条件、规范组和分数。 若在列表条目中重复引用,但没有这些证据,则不会通过重复验证。",
        "将成就、教育或虚构的行为转换成一个精确的智商数是不科学的,因为这些都不是人类的特征。"
      ]
    }
  ],
  "faqs": [
    {
      "question": "是智商 的 200 可能吗？",
      "answer": "一个数字可以出现在一些历史或扩展的评分方法下,但其含义和精度完全取决于仪器和规范。"
    },
    {
      "question": "谁有今天最高的智商?",
      "answer": "目前还没有一个全面、可比、独立核实的全球排名,涵盖了许多测试和分数尺度。"
    }
  ],
  "related": ["iq-160-meaning", "how-is-iq-measured", "albert-einstein-iq"],
  "sources": [
    {
      "label": "心理学词典 — IQ",
      "url": "https://dictionary.apa.org/iq"
    },
    {
      "label": "皮尔逊-西非信息系统5 样本得分报告",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
